import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Home, Sparkles } from 'lucide-react';

export const Hero = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/918667644336', '_blank');
  };

  const scrollToProperties = () => {
    document.getElementById('properties')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#0F1419] via-[#1a2634] to-[#2d3e50]">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#D4AF37] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#D4AF37] rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="animate-fade-in-up">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-4 py-2 mb-8">
            <Sparkles className="w-4 h-4 text-[#D4AF37]" />
            <span className="text-white text-sm font-medium">Premium Real Estate & Interior Design</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 playfair leading-tight">
            Discover Your
            <span className="block mt-2">
              Dream Home with{' '}
              <span className="text-gradient-gold">Elegance</span>
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
            NA Realtors brings you premium properties and exquisite interior design solutions.
            Experience luxury living with our curated selection of homes in Coimbatore's finest locations.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              onClick={scrollToProperties}
              className="bg-[#D4AF37] hover:bg-[#B8941F] text-white px-8 py-6 text-lg font-semibold group"
            >
              <Home className="w-5 h-5 mr-2" />
              Explore Properties
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={handleWhatsApp}
              className="border-2 border-white text-white hover:bg-white hover:text-[#0F1419] px-8 py-6 text-lg font-semibold backdrop-blur-sm"
            >
              Get in Touch
            </Button>
          </div>

          {/* Stats */}
          <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-[#D4AF37] playfair mb-2">500+</div>
              <div className="text-gray-300 text-sm">Properties Sold</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#D4AF37] playfair mb-2">300+</div>
              <div className="text-gray-300 text-sm">Happy Clients</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#D4AF37] playfair mb-2">150+</div>
              <div className="text-gray-300 text-sm">Design Projects</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#D4AF37] playfair mb-2">10+</div>
              <div className="text-gray-300 text-sm">Years Experience</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-[#D4AF37] rounded-full"></div>
        </div>
      </div>
    </section>
  );
};